/**
 * TO CHANGE SOFT LAUNCH VS DEV SETTINGS,
 * SEE "flags" OBJECT BELOW
 */

const buildMode = process.env.NODE_ENV

const dev = buildMode !== "production"

const env = {
  buildMode,
  dev
}

// eslint-disable-next-line no-unused-vars
const devSettings = {
  bubblesMove: true,
  link: {
    // technology: !!env.dev, // based off environment vars
    technology: true, // is the technology page linked
    ourPeople: true, // is the our people page linked
    backOurPeople: true, // is our people linked from bios
    styleguide: !!env.dev, // show only in dev
    authors: true, // should articles link to auhors
    support: true, // are we showing support
    techSpecs: true // hide tech specs? // @TODO: is this even being used?
  },
  visionVideo: false, // is the vision page video displayed
  visionOurPeople: true, // is the vision our people section displayed
  visionThoughLeadership: false, // thoughts/ideas block on vision page
  visionTopBanner: true, // topBanner on vision page
  exoWorksTechSpecs: false, // show exo-works tech specs
  exoWorksSupportOverlay: true, // show the demo overlay contact
  getInTouchSupport: true, // not shown until support is shown
  useReCaptcha: false // enable google recaptcha
}

// eslint-disable-next-line no-unused-vars
const softProdSettings = {
  bubblesMove: true,
  link: {
    // technology: !!env.dev, // based off environment vars
    technology: true, // is the technology page linked
    ourPeople: true, // is the our people page linked
    backOurPeople: true, // is our people linked from bios
    styleguide: false, // show only in dev
    authors: true, // should articles link to auhors
    support: true, // are we showing support
    techSpecs: false // hide tech specs? // @TODO: is this even being used?
  },
  visionVideo: false, // is the vision page video displayed
  visionOurPeople: true, // is the vision our people section displayed
  visionThoughLeadership: false, // thoughts/ideas block on vision page
  visionTopBanner: true, // topBanner on vision page
  exoWorksTechSpecs: false, // show exo-works tech specs
  exoWorksSupportOverlay: false, // show the demo overlay contact
  getInTouchSupport: true, // not shown until support is shown
  useReCaptcha: true // enable google recaptcha
}

const flags = {
  ...env,
  // ...softProdSettings
  ...devSettings
}

const featureFlags = {
  ...flags
}

export default featureFlags
